<div class="constraints-header">
  <div class="constraints-label">{{ 'AI_ASSISTANT.CONSTRAINTS.TITLE' | translate }}</div>
</div>

@if (constraintsForm()) {
  <div [formGroup]="constraintsForm()" class="constraint-section">
    <!-- Viewing Section -->
    <div class="viewing-section">
      <glxy-form-field class="viewing-control">
        <mat-checkbox formControlName="isHidden" color="primary"
          >{{ 'AI_ASSISTANT.CONSTRAINTS.VIEWING.HIDE_FROM_USERS' | translate }}
          <extended>{{ 'AI_ASSISTANT.CONSTRAINTS.VIEWING.HIDE_FROM_USERS_HINT' | translate }}</extended>
        </mat-checkbox>
      </glxy-form-field>
    </div>

    <!-- Assignment Section -->
    <div class="assignment-section" formArrayName="assignmentConstraints">
      <div class="constraints-header">
        <div class="constraints-label">{{ 'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.TITLE' | translate }}</div>
        <mat-icon
          class="info-icon"
          [glxyTooltip]="'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.TOOLTIP_TEXT' | translate"
          glxyTooltipPosition="top"
          >info</mat-icon
        >
      </div>

      @if (!constraintsForm().controls.assignmentConstraints.controls.length) {
        <div class="no-constraints">{{ 'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.NO_RESTRICTIONS' | translate }}</div>
      } @else {
        @for (
          constraintForm of constraintsForm().controls.assignmentConstraints.controls;
          track $index;
          let last = $last
        ) {
          <div class="constraint-group" [formGroupName]="$index">
            <div class="constraint-content">
              <div class="constraint-row">
                <!-- Scope Type -->
                <glxy-form-field [bottomSpacing]="'small'" class="constraint-field">
                  <mat-select
                    formControlName="scopeType"
                    [placeholder]="'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.RESTRICT_BY_PLACEHOLDER' | translate"
                    (selectionChange)="onScopeTypeChange($index, $event.value)"
                  >
                    <mat-option value="assistantType">{{
                      'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.ASSISTANT_TYPE' | translate
                    }}</mat-option>
                    <mat-option value="assistantNamespaceType">{{
                      'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.NAMESPACE_TYPE' | translate
                    }}</mat-option>
                  </mat-select>
                </glxy-form-field>

                <!-- Scope Value -->
                <glxy-form-field [bottomSpacing]="'small'" class="constraint-field">
                  @if (constraintForm.controls.scopeType.value === 'assistantNamespaceType') {
                    <mat-select
                      formControlName="scopeValue"
                      [placeholder]="'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.SELECT_NAMESPACE_TYPE' | translate"
                    >
                      @for (namespaceType of assistantNamespaceTypes | keyvalue; track namespaceType.key) {
                        <mat-option [value]="namespaceType.key">{{ namespaceType.value }}</mat-option>
                      }
                    </mat-select>
                  } @else if (constraintForm.controls.scopeType.value === 'assistantType') {
                    <mat-select
                      formControlName="scopeValue"
                      [placeholder]="'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.SELECT_ASSISTANT_TYPE' | translate"
                    >
                      @for (assistantType of assistantTypes | keyvalue; track assistantType.key) {
                        <mat-option [value]="assistantType.key">{{ assistantType.value }}</mat-option>
                      }
                    </mat-select>
                  } @else {
                    <mat-select
                      disabled
                      [placeholder]="'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.SELECT_RESTRICTION_FIRST' | translate"
                    >
                      <mat-option>{{
                        'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.SELECT_RESTRICTION_FIRST' | translate
                      }}</mat-option>
                    </mat-select>
                  }
                </glxy-form-field>
              </div>
            </div>
            <button mat-icon-button type="button" (click)="removeAssignmentConstraint($index)">
              <mat-icon class="delete-button">close</mat-icon>
            </button>
          </div>
          @if (!last) {
            <mat-divider class="constraint-divider"></mat-divider>
          }
        }
      }

      <button mat-button type="button" color="primary" (click)="addAssignmentConstraint()">
        {{ 'AI_ASSISTANT.CONSTRAINTS.ASSIGNMENT.ADD_RESTRICTION' | translate }}
      </button>
    </div>
  </div>
} @else {
  <div class="loading-message">{{ 'AI_ASSISTANT.CONSTRAINTS.FORM_NOT_AVAILABLE' | translate }}</div>
}
